import axios from 'axios';
import { ICrudGetAction, ICrudGetAllAction, ICrudPutAction, ICrudDeleteAction } from 'react-jhipster';

import { cleanEntity } from 'app/shared/util/entity-utils';
import { REQUEST, SUCCESS, FAILURE } from 'app/shared/reducers/action-type.util';

import { IAuthorization, defaultValue } from 'app/shared/model/authorization.model';
// 请求
export const ACTION_TYPES = {
  FETCH_AUTHORIZATION_LIST: 'authorization/FETCH_AUTHORIZATION_LIST',
  FETCH_AUTHORIZATION: 'authorization/FETCH_AUTHORIZATION',
  CREATE_AUTHORIZATION: 'authorization/CREATE_AUTHORIZATION',
  UPDATE_AUTHORIZATION: 'authorization/UPDATE_AUTHORIZATION',
  DELETE_AUTHORIZATION: 'authorization/DELETE_AUTHORIZATION',
  RESET: 'authorization/RESET'
};
// 定义state类型
const initialState = {
  loading: false,
  errorMessage: null,
  entities: [] as ReadonlyArray<IAuthorization>,
  entity: defaultValue,
  updating: false,
  updateSuccess: false
};

export type AuthorizationState = Readonly<typeof initialState>;

// Reducer

export default (state: AuthorizationState = initialState, action): AuthorizationState => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_AUTHORIZATION_LIST):
    case REQUEST(ACTION_TYPES.FETCH_AUTHORIZATION):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true
      };
    case REQUEST(ACTION_TYPES.CREATE_AUTHORIZATION):
    case REQUEST(ACTION_TYPES.UPDATE_AUTHORIZATION):
    case REQUEST(ACTION_TYPES.DELETE_AUTHORIZATION):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        updating: true
      };
    case FAILURE(ACTION_TYPES.FETCH_AUTHORIZATION_LIST):
    case FAILURE(ACTION_TYPES.FETCH_AUTHORIZATION):
    case FAILURE(ACTION_TYPES.CREATE_AUTHORIZATION):
    case FAILURE(ACTION_TYPES.UPDATE_AUTHORIZATION):
    case FAILURE(ACTION_TYPES.DELETE_AUTHORIZATION):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload
      };
    case SUCCESS(ACTION_TYPES.FETCH_AUTHORIZATION_LIST):
      return {
        ...state,
        loading: false,
        entities: action.payload.data
      };
    case SUCCESS(ACTION_TYPES.FETCH_AUTHORIZATION):
      return {
        ...state,
        loading: false,
        entity: action.payload.data
      };
    case SUCCESS(ACTION_TYPES.CREATE_AUTHORIZATION):
    case SUCCESS(ACTION_TYPES.UPDATE_AUTHORIZATION):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: action.payload.data
      };
    case SUCCESS(ACTION_TYPES.DELETE_AUTHORIZATION):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: {}
      };
    case ACTION_TYPES.RESET:
      return {
        ...initialState
      };
    default:
      return state;
  }
};

const apiUrl = 'api/authorizations';

// Actions

export const getEntities: ICrudGetAllAction<IAuthorization> = (page, size, sort) => ({
  type: ACTION_TYPES.FETCH_AUTHORIZATION_LIST,
  payload: axios.get<IAuthorization>(`${apiUrl}?cacheBuster=${new Date().getTime()}`)
});

export const getEntity: ICrudGetAction<IAuthorization> = id => {
  const requestUrl = `${apiUrl}/${id}`;
  return {
    type: ACTION_TYPES.FETCH_AUTHORIZATION,
    payload: axios.get<IAuthorization>(requestUrl)
  };
};

export const createEntity: ICrudPutAction<IAuthorization> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.CREATE_AUTHORIZATION,
    payload: axios.post(apiUrl, cleanEntity(entity))
  });
  dispatch(getEntities());
  return result;
};

export const updateEntity: ICrudPutAction<IAuthorization> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_AUTHORIZATION,
    payload: axios.put(apiUrl, cleanEntity(entity))
  });
  dispatch(getEntities());
  return result;
};

export const deleteEntity: ICrudDeleteAction<IAuthorization> = id => async dispatch => {
  const requestUrl = `${apiUrl}/${id}`;
  const result = await dispatch({
    type: ACTION_TYPES.DELETE_AUTHORIZATION,
    payload: axios.delete(requestUrl)
  });
  dispatch(getEntities());
  return result;
};

export const reset = () => ({
  type: ACTION_TYPES.RESET
});
